module.exports = __webpack_public_path__ + "dbb4a2d149b90d20704e6e3641b6eec2.pdf";